import React from 'react';
import { siteConfig } from '../data/mock';

const AICoachPage = () => {
  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero Section with Logo */}
      <section className="py-8 bg-[#F8F9FA] relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <img
            src={siteConfig.logo}
            alt=""
            className="w-[500px] h-[500px] object-contain opacity-100"
          />
        </div>

        <div className="container-custom relative z-10">
          <div className="text-center max-w-2xl mx-auto bg-white/95 backdrop-blur-sm p-6 rounded-lg border-2 border-[#1E3A8A]">
            <p className="text-[#E31837] font-semibold text-lg mb-3 tracking-wide uppercase">AI-Powered Support</p>
            <h1 className="text-[#1E3A8A] text-3xl md:text-4xl font-bold mb-4">
              Your <span className="text-[#E31837]">AI Wellness Coach</span>
            </h1>
            <p className="text-[#1E3A8A] text-lg">
              Get instant answers about the 7 Domains of Wellness and our 12-week program. Available 24/7.
            </p>
          </div>
        </div>
      </section>

      {/* JotForm Agent Embed Section */}
      <section className="py-8 bg-white relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <img
            src={siteConfig.logo}
            alt=""
            className="w-[600px] h-[600px] object-contain opacity-50"
          />
        </div>

        <div className="container-custom relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/95 backdrop-blur-sm rounded-lg border-2 border-[#1E3A8A] overflow-hidden shadow-lg">
              <iframe
                src="https://agent.jotform.com/019b862160fc764db91b096fa53aff8356e7"
                title="AI Wellness Coach"
                className="w-full h-[600px] border-0"
                allow="microphone; camera"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AICoachPage;
